import { NgModule } from "@angular/core";
import { FormsModule } from '@angular/forms';
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

import { ServiceObjectSearchComponent } from "app/client/serviceObject/search/serviceObject-search.component";

@NgModule({
  declarations: [
    ServiceObjectSearchComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    RouterModule
  ],
  entryComponents: [
    ServiceObjectSearchComponent
  ]
})
export class ServiceObjectSearchModule { }



// WEBPACK FOOTER //
// /app/SPA/src/app/client/serviceObject/search/serviceObject-search.module.ts